export default {
    managers: {
        create: {
            title: 'Add Manager',
            subtitle: 'Role Information',
            successMessage: 'New Manager has been added'
        },
        edit: {
            title: 'Edit Manager',
            subtitle: 'Role Information',
            successMessage: 'Manager Information Updated',
            successMessageAvatar: 'Manager Avatar Updated',
            successMessageAvatarDeleted: 'Manager Avatar Deleted',
            settings: {
                title: 'Account Settings',
                uploadTitle: 'Upload Avatar Image',
                deactivate: {
                    title: 'Deactivate Account',
                    description:
                        'When you deactivate their account, the Manager’s information will be saved, but they will no longer be able to access the Chill App. Ready to jump back in? Click the toggle to reactivate their account.',
                    successMessageActivated: 'The account has been Activated',
                    successMessageDeactivated:
                        'The account has been Deactivated'
                },
                delete: {
                    title: 'Delete Account',
                    description:
                        'Click the button below to delete their account which will permanently remove the Manager’s access to and information from the Chill App.',
                    button: 'Delete account',
                    successMessage: 'The account has been deleted'
                },
                reset: {
                    title: 'Reset Password',
                    description:
                        'Click the button below, and a password reset link will be automatically sent to their email address. They’ll be back on the Chill App in no time.',
                    button: 'Reset password',
                    successMessage: 'The account has been reseted'
                }
            },
            confirmation: {
                delete: {
                    title: 'Delete Account',
                    description:
                        'Are you sure you want to permanently delete this Manager’s account?'
                }
            }
        },
        list: {
            title: 'Managers',
            createButton: 'Add manager',
            createButtonMobile: 'Add',
            status: {
                active: 'Active',
                inactive: 'Inactive'
            }
        },
        tableHeaders: [
            { text: 'Full Name', value: 'fullName' },
            { text: 'Email', value: 'email' },
            { text: 'Phone Number', value: 'phone', sortable: false },
            {
                text: 'Status',
                value: 'isActive',
                sortable: false,
                filter: [
                    {
                        title: 'All',
                        value: null
                    },
                    {
                        title: 'Active',
                        value: true
                    },
                    {
                        title: 'Inactive',
                        value: false
                    }
                ]
            },
            {
                text: 'Role',
                value: 'role',
                sortable: false,
                filter: [
                    {
                        title: 'All',
                        value: null
                    },
                    {
                        title: 'Admins',
                        value: 'admin'
                    },
                    {
                        title: 'Instructors',
                        value: 'instructor'
                    }
                ]
            },
            { text: 'Actions', class: 'actions', sortable: false }
        ],
        mobile: {
            sort: {
                fullName: 'Sort by Full Name',
                email: 'Sort by Email'
            },
            filter: {
                status: {
                    name: 'Filter by Status',
                    filter: [
                        {
                            text: 'All',
                            value: null
                        },
                        {
                            text: 'Active',
                            value: true
                        },
                        {
                            text: 'Inactive',
                            value: false
                        }
                    ]
                },
                role: {
                    name: 'Filter by Role',
                    filter: [
                        {
                            text: 'All',
                            value: null
                        },
                        {
                            text: 'Admins',
                            value: 'admin'
                        },
                        {
                            text: 'Instructors',
                            value: 'instructor'
                        }
                    ]
                }
            }
        }
    }
};
